import * as React from 'react';

import { EyeIcon, EyeSlashIcon } from '@icons';

import { Separator } from '@components/separator';

import * as Styled from './input.styled';

type OwnProps = {
	label?: string;
	isRequired?: boolean;
	isPassword?: boolean;
	icon?: React.FC;
	inputSize?: Styled.InputProps['$inputSize'];
	errorMessage?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

const Input: React.FC<OwnProps> = ({
	label,
	isRequired,
	isPassword,
	icon: Icon = null,
	inputSize = Styled.INPUT_SIZE.REGULAR,
	errorMessage,
	...inputProps
}) => {
	const [isHidden, setIsHidden] = React.useState(isPassword);

	return (
		<Styled.Wrapper>
			{label && (
				<Styled.Label>
					{label} {isRequired && <span>*</span>}
				</Styled.Label>
			)}
			<Styled.InputWrapper>
				{Icon && (
					<Styled.InputIcon $position='start'>
						<Icon />
					</Styled.InputIcon>
				)}
				<Styled.InputStyled
					{...inputProps}
					$hasSuffix={isPassword}
					$hasPrefix={!!Icon}
					$inputSize={inputSize}
					type={isHidden ? 'password' : 'text'}
				/>
				{isPassword && (
					<Styled.InputIcon $position='end' onClick={() => setIsHidden(prev => !prev)}>
						{isHidden ? <EyeIcon /> : <EyeSlashIcon />}
					</Styled.InputIcon>
				)}
				{errorMessage ? (
					<>
						<Separator height={16} />
						<Styled.Label $isError>{errorMessage}</Styled.Label>
					</>
				) : null}
			</Styled.InputWrapper>
		</Styled.Wrapper>
	);
};

export default React.memo(Input);
